import { render, staticRenderFns } from "./user-management-list.vue?vue&type=template&id=138ca14a&scoped=true"
import script from "./user-management-list.vue?vue&type=script&lang=js"
export * from "./user-management-list.vue?vue&type=script&lang=js"
import style0 from "./user-management-list.vue?vue&type=style&index=0&id=138ca14a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138ca14a",
  null
  
)

export default component.exports